<template>
  <div>
    <div v-for="(branch, i) in value" v-bind:key="'branch' + i">
      <div v-bind:style="branchStyle" v-bind:class="getBranchClass(branch)">
        <div class="row g-0">
          <div v-if="isSelectable(branch)" class="col-auto form-check">
            <input type="checkbox" v-on:change.prevent="toggleSelected(branch)" v-bind:checked="branch.selected"/>
          </div>
          <div v-on:click.prevent="toggleExpand(branch)" class="col-auto">
            <a v-if="branch.href" v-bind:href="branch.href" v-bind:style="branch.textStyle"
               v-bind:class="branch.textClass">
              <i v-if="branch.iconClass" v-bind:style="branch.iconStyle" v-bind:class="branch.iconClass"></i>
              {{ branch.text }}
            </a>
            <span v-else=""
                  v-bind:style="branch.textStyle"
                  v-bind:class="branch.textClass">
              <i v-if="branch.iconClass" v-bind:style="branch.iconStyle" v-bind:class="branch.iconClass"></i>
              {{ branch.text }}
            </span>
          </div>
          <div v-if="branch.buttons && branch.buttons.length" class="col-auto">
            <template v-for="(button, j) in branch.buttons">
              <a v-if="button.href" v-bind:key="'a' + j" v-bind:href="button.href" v-on:click.prevent="button.onClick(branch.id)"
                 v-bind:style="button.buttonStyle" v-bind:class="button.buttonClass">
                <i v-if="button.iconClass" v-bind:style="button.iconStyle" v-bind:class="button.iconClass"></i>
                <template v-if="button.text">{{ button.text }}</template>
              </a>
              <button v-else="" v-bind:key="'button' + j" v-on:click.prevent="button.onClick(branch.id)" v-bind:style="button.buttonStyle"
                      v-bind:class="button.buttonClass">
                <i v-if="button.iconClass" v-bind:style="button.iconStyle" v-bind:class="button.iconClass"></i>
                <template v-if="button.text">{{ button.text }}</template>
              </button>
            </template>
          </div>
          <div v-on:click.prevent="toggleExpand(branch)" class="col">
          </div>
          <div v-if="isExpandable(branch)" v-on:click.prevent="toggleExpand(branch)" class="col-auto">
            <i class="fal"
               v-bind:class="{'fa-chevron-right': !branch.expanded, 'fa-chevron-down': branch.expanded}"></i>
          </div>
        </div>
      </div>
      <transition v-if="isExpandable(branch)" name="new-menu-slide">
        <div v-show="branch.expanded" class="row g-0">
          <div class="col-auto">
            <div class="px-3"></div>
          </div>
          <div class="col">
            <tree-branch v-model="branch.children"
                         v-bind:branch-style="branchStyle"
                         v-bind:branch-class="branchClass"/>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: "tree-branch",
  props: {
    value: {},
    branchStyle: {
      type: String
    },
    branchClass: {
      type: String
    },
  },
  methods: {
    isSelectable: function (branch) {
      return Object.prototype.hasOwnProperty.call(branch, "selected");
    },
    isExpandable: function (branch) {
      return branch.children && branch.children.length;
    },
    getBranchClass: function (branch) {
      var cls = "";
      if (this.isSelectable(branch)) {
        cls += "selectable ";
        if (branch.selected) {
          cls += "selected ";
        } else {
          cls += "unselected ";
        }
      }
      if (this.isExpandable(branch)) {
        cls += "expandable ";
        if (branch.expanded) {
          cls += "expanded ";
        } else {
          cls += "collapsed ";
        }
      }
      if (this.branchClass) {
        cls += this.branchClass;
      }
      return cls;
    },
    toggleExpand: function (branch) {
      if (branch.onToggleExpanded) {
        branch.onToggleExpanded(branch);
      }
    },
    toggleSelected: function (branch) {
      if (branch.onToggleSelected) {
        branch.onToggleSelected(branch);
      }
    }
  }
}
</script>
